import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

// Components
import Image from './Image';
import Initials from './Initials';

// Styles
import styles from './styles.js';

class Avatar extends Component {
    static propTypes = {
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        userImageSrc: PropTypes.string
    }

    render() {
        const { firstName, lastName, userImageSrc } = this.props;
        let firstInitial = '';
        let lastInitial = '';
        if (typeof firstName === 'undefined' || firstName === null || firstName === '') {
            firstInitial = 'U'; // for User
        } else {
            firstInitial = firstName.charAt(0);
        }
        if (typeof lastName === 'undefined' || lastName === null || lastName === '') {
            lastInitial = 'P'; // for Profile
        } else {
            lastInitial = lastName.charAt(0);
        }
        const initials = firstInitial + lastInitial;
        return (
            <div className={css(styles.wrapper)}>
                <div className={css(styles.container)}>
                    {(userImageSrc !== null) ? (
                        <Image
                            src={userImageSrc}
                            username={firstName}
                        />
                    ) : <Initials initials={initials} />}
                </div>
            </div>
        );
    }
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Avatar.jsx